import React from 'react';
import { CircleSpinner } from 'react-spinners-kit';
import { Box } from '@mui/material';

const Loader = ({ load }) =>
  load && (
    <Box display="flex" justifyContent="center" sx={{ p: 3 }}>
      <CircleSpinner size={30} color="#ec8181" loading={load} />
    </Box>
  );

export default Loader;
